import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { isEmpty } from 'validate.js';

import { isLessThanBreakpoint } from 'dpl/util/grid';
import { FILTER_COAT } from 'dpl/constants/query_params';
import {
  ANALYTICS_VIEWS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEW_FEATURE_LOCATIONS
} from 'dpl/constants/analytics';

import FilterPill from './FilterPill';
import ExposedFilterBottomModal from './ExposedFilterBottomModal';
import ExposedFilterDropdown from './ExposedFilterDropdown';
import MultiSelectChecklistFilter from './MultiSelectChecklistFilter';

const IS_LT_MD = isLessThanBreakpoint('md');

const FILTER_TITLE = 'Filter by coat type';

export default function CoatTypeFilterButton({ resultsType, totalItemCount }) {
  const breedCoat = useSelector(({ server }) => server.breedCoat);
  const isSelected = useSelector(({ queryParams }) =>
    Boolean(queryParams[FILTER_COAT])
  );
  const [isCoatTypeFilterOpen, setIsCoatTypeFilterOpen] = useState(false);

  const analytics = {
    button_cta: 'coat type',
    view: ANALYTICS_VIEWS.PUPPY_SEARCH_RESULTS,
    view_feature: ANALYTICS_VIEW_FEATURES.COAT_TYPE_FILTER_BUTTON,
    view_feature_location: ANALYTICS_VIEW_FEATURE_LOCATIONS.SEARCH_HEADER
  };

  const FilterButton = (
    <FilterPill
      onClick={() => setIsCoatTypeFilterOpen(true)}
      label="Coat type"
      displayDropdownArrow
      isSelected={isSelected}
      analytics={analytics}
      isOpen={isCoatTypeFilterOpen}
    />
  );

  if (isEmpty(breedCoat)) {
    return null;
  }

  if (IS_LT_MD) {
    return (
      <>
        {FilterButton}
        <ExposedFilterBottomModal
          isFilterMenuOpen={isCoatTypeFilterOpen}
          setIsFilterMenuOpen={setIsCoatTypeFilterOpen}
          resultsType={resultsType}
          totalItemCount={totalItemCount}
          title={FILTER_TITLE}
        >
          <MultiSelectChecklistFilter
            filterParam={FILTER_COAT}
            filterOptions={breedCoat}
          />
        </ExposedFilterBottomModal>
      </>
    );
  }

  return (
    <ExposedFilterDropdown
      isOpen={isCoatTypeFilterOpen}
      setIsOpen={setIsCoatTypeFilterOpen}
      toggleButton={FilterButton}
      title={FILTER_TITLE}
      setIsMenuOpen={() => setIsCoatTypeFilterOpen(false)}
      totalItemCount={totalItemCount}
      resultsType={resultsType}
    >
      <div className="mb4">
        <MultiSelectChecklistFilter
          filterParam={FILTER_COAT}
          filterOptions={breedCoat}
        />
      </div>
    </ExposedFilterDropdown>
  );
}
CoatTypeFilterButton.propTypes = {
  resultsType: PropTypes.string.isRequired,
  totalItemCount: PropTypes.number.isRequired
};
